import { useState } from "react";
import { RightDrawerContext } from "./RightDrawerContext";
import AddMemberContainer from "../addMember/AddMemberContainer";
import ChatAssetsTabs from "../chatInfo/tabs/info/common/assets/ChatAssetsTabs";
import { ChatInfo } from "../chatInfo/ChatInfo";
import { IBroadcastInfo, IGroupInfo } from "@home-health-notify/domain";

type RightDrawerProviderType = {
  children: React.JSX.Element;
};

export const RightDrawerProvider = ({ children }: RightDrawerProviderType) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<React.JSX.Element>();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const openAddMembersDrawer = (
    groupInfo: IGroupInfo | IBroadcastInfo,
    showBackButton: boolean = true,
  ) => {
    setContent(
      <AddMemberContainer
        chatId={groupInfo.id}
        groupType={groupInfo.groupType}
        showBackButton={showBackButton}
      />,
    );
    handleDrawerOpen();
  };

  const openChatInfoDrawer = (tabValue?: number) => {
    setContent(<ChatInfo tabValue={tabValue} />);
    handleDrawerOpen();
  };

  const openChatAssets = () => {
    setContent(<ChatAssetsTabs onClose={() => {}} />);
    handleDrawerOpen();
  };

  return (
    <RightDrawerContext.Provider
      value={{
        open,
        setOpen,
        content,
        setContent,
        openDrawer: handleDrawerOpen,
        closeDrawer: handleDrawerClose,
        openAddMembersDrawer,
        openChatInfoDrawer,
        openChatAssets,
      }}
    >
      {children}
    </RightDrawerContext.Provider>
  );
};
